






























import {
    Component,
    ComponentConfig, Inject, InjectComponent,
    ProductPropertyDefinition,
    ProductRecommendation,
    Prop, Vue, VueComponent
} from "@zoovu/runner-browser-api";
import {
    PriceConfiguration,
    Placement,
    TextPlacements,
} from "../configuration";
import {
    LocalizationSettings,
    PriceComplementaryTextContent
} from "./types";
import {formatNumberAsCurrency} from "./utils";

@Component({})
export default class ProductPriceView extends Vue {
    @InjectComponent("ProductPriceComplementaryTextView")
    productPriceComplementaryTextView: VueComponent;

    @Inject() readonly localizationSettings!: LocalizationSettings;

    @ComponentConfig(PriceConfiguration)
    price: PriceConfiguration;

    @Prop()
    recommendation!: ProductRecommendation;

    @Prop({ default: true })
    showComplementaryTexts!: boolean;

    get shouldShowPrice(): boolean {
        return this.recommendation.price.rawValue.value > 0;
    }

    get complementaryTextsBefore(): ReadonlyArray<PriceComplementaryTextContent> {
        return this.complementaryTexts.filter(text => text.placement === Placement.TOP || text.placement === Placement.LEFT);
    }

    get complementaryTextsAfter(): ReadonlyArray<PriceComplementaryTextContent> {
        return this.complementaryTexts.filter(text => text.placement === Placement.BOTTOM || text.placement === Placement.RIGHT);
    }

    get complementaryTexts(): ReadonlyArray<PriceComplementaryTextContent> {
        if (!this.price || !this.price.settings || !this.price.settings.textPlacements)
            return [];

        const textPlacements: TextPlacements = this.price.settings.textPlacements;

        return Object.entries(textPlacements).map(([placement, { column, isPrice, text, isReversed }]) => {
            const columnName = column && column.name;
            const property = columnName && this.getProperty(columnName);
            const columnValue = property && property.value || "";
            const columnText = isPrice && columnValue ? formatNumberAsCurrency(columnValue, this.localizationSettings) : columnValue.toString();
            const isHidden = isPrice && (!columnValue || this.recommendation.price.rawValue.value === columnValue);
            const hasColumnAssigned = !!columnName;

            return {
                staticText: text,
                columnText,
                classList: [`price-additional-text--${placement}`, {"is-reversed": isReversed, "price-additional-text--hidden": isHidden}],
                placement,
                hasColumnAssigned
            }
        }).filter(textContent => {
            return textContent.staticText && textContent.columnText.length ||
                textContent.staticText && !textContent.hasColumnAssigned ||
                textContent.hasColumnAssigned && textContent.columnText.length
        });
    };

    getProperty(propertyName: string): ProductPropertyDefinition {
        if (!propertyName) {
            return null;
        }

        if (!this.recommendation.additionalProperties[propertyName]) {
            const foundProperty = this.recommendation.productDefinition[propertyName];

            if (!foundProperty || !foundProperty.hasOwnProperty("value")) {
                return null;
            }
            return foundProperty;
        }
        return this.recommendation.additionalProperties[propertyName];
    }
}
